import { NoticeFile } from "./NoticeFile";

export const NoticeFiles = ({notice})=>{


    return (
    <div className="attachFiles">
        {
            notice.data?.files.map((file)=>{
                if(file.mime==='image/gif' || file.mime==='image/png' || file.mime==='image/jpeg' )return null;
                return <NoticeFile file={file} key={file.id} />;
            })
        } 
    </div>
    );
}

;